import React, { FunctionComponent } from 'react';
import withStyles from 'react-jss';
import classnames from 'classnames';
import { Form, FormSelectProps } from 'semantic-ui-react';

import { ClassProp } from 'helpers/types';

import styles from './FormSelect.styles';

type Props = FormSelectProps & {
  classes: ClassProp<typeof styles>;
};

const StyledFormSelect: FunctionComponent<Props> = ({
  classes,
  className,
  loading,
  ...props
}) => (
  <Form.Select
    {...props}
    loading={loading}
    className={classnames(classes.formSelect, className)}
  />
);

export default withStyles(styles)(StyledFormSelect);
